{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "shop",
  "roles": {
    "primary": [
      "technician",
      "inspector",
      "lead-technician",
      "production-control"
    ],
    "supporting": [
      "planner",
      "parts-coordinator",
      "records-specialist",
      "customer-service"
    ],
    "governance": [
      "quality-manager",
      "accountable-manager",
      "shop-administrator"
    ],
    "external": [
      "aircraft-owner",
      "operator-representative"
    ]
  },
  "orgTypes": [
    "part-145",
    "independent-mro",
    "mobile-aog",
    "oem-service",
    "component-shop",
    "operator-internal-mx",
    "integrated-135-145"
  ],
  "extensions": [
    "byom",
    "co-build",
    "ironfleet-network",
    "data-migration",
    "integrations",
    "workflow-extensions",
    "esign-readiness",
    "wearable-inspection",
    "premium-support"
  ],
  "integrations": [
    "quantum",
    "corridor",
    "veryon",
    "partsbase",
    "accounting-erp",
    "sharepoint"
  ]
}